import { Component, Input, OnInit } from '@angular/core';

interface GalleryPhoto {
  image: string;
  title: string;
  /** Optional rich-text (HTML) caption, e.g. the "Nuestra Casa" item description */
  description?: string;
  /** Optional "Ver más" link target (used by the card layout) */
  url?: string;
}

@Component({
  selector: 'app-sblock-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class SblockGalleryComponent implements OnInit {
  @Input() title = '';
  @Input() subtitleText = '';
  @Input() bodyHtml ='';
  label = '';

  showTitles = true;
  @Input() isTinyGallery = false;
  /** Shows skeleton placeholders while the parent is fetching data */
  @Input() loading = false;
  /** Render the current photo's title + description (HTML) under the image */
  @Input() showCaptions = false;
  /** Show the bottom action buttons (hidden when there's no real destination) */
  @Input() showActions = true;
  /**
   * Home-only layout: image on the left, caption (title + description) on the
   * right, inside a white card. Defaults to false so other usages (LevelProfile)
   * keep the full-width image layout.
   */
  @Input() cardLayout = false;
  currentIndex = 0;

  /** Photos come from the parent; no placeholder/demo fallbacks */
  private _photos: GalleryPhoto[] = [];

  @Input() set photos(value: GalleryPhoto[]) {
    this._photos = value || [];
    this.currentIndex = 0;
  }
  get photos(): GalleryPhoto[] {
    return this._photos;
  }

  /** Skeleton tiles rendered while loading */
  skeletonTiles = [0, 1, 2];

  primaryButton = { label: 'Ver toda la galeria', url: '#', target: '_self' };
  secondaryButton = { label: 'Conocer mas', url: '#', target: '_self' };

  get hasHeaderContent(): boolean {
    return !!(this.title || this.subtitleText || this.bodyHtml);
  }

  get currentPhoto(): GalleryPhoto | null {
    return this.photos.length > 0 ? this.photos[this.currentIndex] : null;
  }

  get tinyPhotos(): GalleryPhoto[] {
    if (this.photos.length === 0) {
      return [];
    }
    return [this.photos[this.currentIndex]];
  }

  ngOnInit(): void {}

  selectPhoto(index: number): void {
    if (index >= 0 && index < this.photos.length) {
      this.currentIndex = index;
    }
  }

  prev(): void {
    const total = this.photos.length;
    if (total === 0) {
      return;
    }
    this.currentIndex = (this.currentIndex - 1 + total) % total;
  }

  next(): void {
    const total = this.photos.length;
    if (total === 0) {
      return;
    }
    this.currentIndex = (this.currentIndex + 1) % total;
  }

  getImage(photo: GalleryPhoto): string {
    return photo ? photo.image : '';
  }

  hasTitleLink(): boolean {
    return false;
  }

  goToLink(): void {}
}
